<template>
  <div>
    <div class="form__input">
      <label class="form__label">
        Government Photo Id File
      </label>
      <div class="custom-file-container">
        <b-form-file
          id="governmentIdFileUpload"
          :value="governmentId.file"
          @change="handleEmit"
          name="governmentIdFileUpload"
          accept="image/*,application/pdf,application/msword"
          placeholder="Select an image, PDF, DOC, or DOCX file"
          drop-placeholder="Drop file here..."
          :state="Boolean(governmentId.file)"
        />
        <font-awesome-icon
          :icon="['fa', 'file-upload']"
          class="icon alt"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'GovernmentId',

  props:{
    value: {
      type: Object,
      required: false,
      default: () => ({
        file: null
      })
    }
  },
  data() {
    return {
      governmentId: {
        file: null
      },
    }
  },
  watch: {
    value() {
      if(this.value)
        this.governmentId = this.value;
      else if (!this.governmentId)
        this.governmentId = {
          file: null
        }
    }
  },
  async mounted() {
    if(this.value)
      this.governmentId = this.value;
    else if (!this.governmentId)
      this.governmentId = {
        file: null
      }
  },
  computed: {
    isValid(){
      return !!this.governmentId.file;
    }
  },
  methods:{
    handleEmit(event){
      const file = event.target.files[0];

      this.governmentId.file = file;

      if(!this.isValid)
        this.$emit('input', null)
      
      this.$emit('input', { ...this.governmentId })
    }
  }
}
</script>

<style>

</style>